const formatUOMLabel = label => {

    return label.replace('SquareFootage', 'SquareFeet').replace(/([a-z](?=[A-Z]))/g, '$1 ');
};

export {
    formatUOMLabel,
};
